import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'colorEvento'
})
export class ColorEventoPipe implements PipeTransform {

  transform(evento: string): string {

    let backgroundColor: string;

    switch (evento) {
      // reporte de alarmas
      case 'SOS':
        backgroundColor = '#FF0000';
        break;

      case 'MEDICA':
        backgroundColor = '#877AFF';
        break;

      case 'FUEGO':
        backgroundColor = '#F8E71C';
        break;

      case 'COACCION':
        backgroundColor = '#54DFC3';
        break;

      case 'RESET':
        backgroundColor = '#4CAF50';
        break;

      case 'ALARMA_ZONA':
        backgroundColor = '#FFBD6B';
        break;

      case 'DESCONECTADO':
        backgroundColor = '#B4B4B4';
        break;

      case 'DESARMADO':
        backgroundColor = '#FB8061';
        break;
      // reporte de fallas
      case 'FALLA_ACC':
        backgroundColor = '#4285F4';
        break;

      case 'FALLA_GSM':
        backgroundColor = '#0252B0';
        break;

      case 'BATERIA':
        backgroundColor = '#43E3E0';
        break;

      case 'BATERIA_SENSOR':
        backgroundColor = '#40B5C9';
        break;

      case 'ERROR_RED':
        backgroundColor = '#37CBFD';
        break;

      case 'RECONEXION':
        backgroundColor = '#47d147';
        break;

      case 'ARMADO_ZONA':
        backgroundColor = '#c68c53';
        break;

      case 'DESACTIVAR_ALERTA':
        backgroundColor = '#ffb3b3';
        break;

      default:
        backgroundColor = '#FB8061';
        break;
    }

    return backgroundColor;
  }

}
